import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient, getHttpClient } from '@edx/frontend-platform/auth';
import { errorHandler } from '@optimizely/react-sdk';
import * as QueryString from 'query-string';

export async function registerRequest(registrationInformation) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    isPublic: true,
  };

  const { data } = await getAuthenticatedHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/api/user/v2/account/registration/`,
      QueryString.stringify(registrationInformation),
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return {
    redirectUrl: data.redirect_url || `${getConfig().LMS_BASE_URL}/dashboard`,
    success: data.success || false,
    authenticatedUser: data.authenticated_user,
  };
}

export async function getFieldsValidations(formPayload) {
  const requestConfig = {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  };

  const { data } = await getHttpClient()
    .post(
      `${getConfig().LMS_BASE_URL}/api/user/v1/validation/registration`,
      QueryString.stringify(formPayload),
      requestConfig,
    )
    .catch((e) => {
      throw (e);
    });

  return {
    fieldValidations: data,
  };
}

export async function getHighSchool(region,city) {
  try{
  const {data} = await getAuthenticatedHttpClient()
  .get(
   `${getConfig().LMS_BASE_URL}/rg/api/school?region=${region}&city=${city}`
  )
  return (JSON.parse(data["schools"]));
}
catch {
  return []
}
}

export async function getUniversities(region,city,isTeacher) {
  try{
  const {data} = await getAuthenticatedHttpClient()
  .get(
   `${getConfig().LMS_BASE_URL}/rg/api/universities?region=${region}&city=${city}&is_teacher=${isTeacher}`
  )
  return (JSON.parse(data["universities"]));
}
catch {
  return []
}
}


export async function getPrimaryhSchool(region,city) {
  try{
  const {data} = await getAuthenticatedHttpClient()
  .get(
   `${getConfig().LMS_BASE_URL}/rg/api/school?region=${region}&city=${city}&only_high=false`
  )
  return (JSON.parse(data["schools"]));
}
catch {
  return []
}
}
